import { loadMessages, locale } from "devextreme/localization";
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import itMessages from "devextreme/localization/messages/it.json";
import moment from 'moment-timezone';
import 'moment/locale/de-ch';
import 'moment/locale/fr-ch';
import 'moment/locale/it';
import Core from '../Core';
import AppHistory from './AppHistory';
import Pdb from './Pdb';
var CultureHelpers = /** @class */ (function () {
    function CultureHelpers() {
        //App default culture
        this.defaultCulture = 'de';
        //PouchDb document name
        this.storageDocName = 'lang';
    }
    //Class Initializer
    CultureHelpers.prototype.Init = function () {
        var that = this;
        return new Promise(function (resolve) {
            that.DbGet().then(function (res) {
                document.documentElement.lang = res;
                that.InitMoment(res);
                that.InitDevextreme(res);
                resolve();
            }).catch(function (err) {
                console.error(err);
            });
        });
    };
    ;
    //Set moment to current culture
    CultureHelpers.prototype.InitMoment = function (culture) {
        if (culture !== "en") {
            if (culture === "de") {
                culture = "de-ch";
            }
            else if (culture === "fr") {
                culture = "fr-ch";
            }
            else if (culture === "it") {
                culture = "it";
            }
        }
        moment.locale(culture);
    };
    //Set devextreme locale
    CultureHelpers.prototype.InitDevextreme = function (culture) {
        if (culture !== "en") {
            if (culture === "de") {
                loadMessages(deMessages);
            }
            else if (culture === "fr") {
                loadMessages(frMessages);
            }
            else if (culture === "it") {
                loadMessages(itMessages);
            }
            locale(culture);
        }
    };
    //Get current language document
    CultureHelpers.prototype.DbGet = function () {
        var that = this;
        var lang = this.defaultCulture;
        return new Promise(function (resolve, reject) {
            Pdb.Get(that.storageDocName).then(function (result) {
                that.doc = result;
                lang = that.doc.value;
                resolve(lang);
            }).catch(function (err) {
                that.InitLangStorage().then(function (langInit) {
                    resolve(langInit);
                }).catch(function (err) {
                    console.error(err);
                });
            });
        });
    };
    //Store languade data
    CultureHelpers.prototype.InitLangStorage = function () {
        this.doc = {
            _id: this.storageDocName,
            value: this.defaultCulture,
            _rev: ''
        };
        return this.Set(this.doc.value, false);
    };
    ;
    //Get current language (two letter ISO code)
    CultureHelpers.prototype.Get = function () {
        if (this.doc !== undefined && this.doc !== null) {
            return this.doc.value.toLowerCase();
        }
        else {
            console.warn('[Culture] - Language not available! Get default');
            return this.defaultCulture;
        }
    };
    ;
    //Set new language two letter ISO code
    CultureHelpers.prototype.Set = function (lang, redirect) {
        if (redirect === void 0) { redirect = true; }
        var that = this;
        that.doc.value = lang;
        return new Promise(function (resolve, reject) {
            Pdb.Put(that.doc).then(function (res) {
                if (res.ok) {
                    that.doc._rev = res.rev;
                    if (redirect) {
                        if (Core.IsNative) {
                            window.location.href = AppHistory.NativeBasePath;
                        }
                        else {
                            window.location.reload();
                        }
                    }
                    else {
                        resolve(lang);
                    }
                }
                else {
                    resolve(lang);
                }
            }).catch(function (err) {
                console.error(err);
                reject(err);
            });
        });
    };
    //Get moment instance with Zurich time zone
    CultureHelpers.prototype.GetMoment = function (inp, format, _strict) {
        if (inp === void 0) { inp = null; }
        if (format === void 0) { format = null; }
        if (_strict === void 0) { _strict = null; }
        var timeZone = 'Europe/Zurich';
        return inp === null ? moment().tz(timeZone) :
            format === null ? moment(inp).tz(timeZone) : moment(inp, format).tz(timeZone);
    };
    //Moment to locale date
    CultureHelpers.prototype.MomentToDate = function (date) {
        return date.local(true).toDate();
    };
    //Moment to locale formatted date string
    CultureHelpers.prototype.MomentToDateString = function (date) {
        return date.local(true).format('DD.MM.YYYY');
    };
    //Moment to locale formatted hour string
    CultureHelpers.prototype.MomentToHourString = function (date) {
        return date.local(true).format('HH:mm');
    };
    //Moment to locale formatted date and time string
    CultureHelpers.prototype.MomentToDateTimeString = function (date) {
        return this.MomentToDateString(date) + " " + this.MomentToHourString(date);
    };
    return CultureHelpers;
}());
var Culture = new CultureHelpers();
export default Culture;
//# sourceMappingURL=Culture.js.map